import styled from "styled-components/macro";

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
`;

export { FlexRow };
